import {BankAccount} from '../model/bank-account';
import {BankAccountService} from '../service/bank-account.service';
import {Injectable} from '@angular/core';
import {StorageService} from '../service/storage.service';
import {LoanApplicationInteractor} from './loan-application.interactor';
import {Proof} from '../model/Proof';
import {LoanApplicationDocumentType} from '../model/loan-application-document-type.model';

@Injectable()
export class BankAccountInteractor {
    constructor(private bankAccountService: BankAccountService, private storageService: StorageService, private loanApplicationInteractor: LoanApplicationInteractor) {
    }

    public async create(bankAccount: BankAccount): Promise<BankAccount> {
        return await this.bankAccountService.create(bankAccount);
    }

    public async get(bankAccountId: string): Promise<BankAccount> {
        return await this.bankAccountService.get(bankAccountId);
    }

    public async update(bankAccount: BankAccount): Promise<void> {
        await this.bankAccountService.update(bankAccount);
    }

    public async addBankStatementDocuments(fileIds: string[]): Promise<void> {
        const loanApplication = await this.loanApplicationInteractor.get();
        const bankAccount = await this.get(loanApplication.bankAccountId);

        if (bankAccount.proofs && bankAccount.proofs.length > 0) {
            bankAccount.proofs[0].fileIds.push(...fileIds);
        } else {
            const proof = new Proof(LoanApplicationDocumentType.BANK_STATEMENT);
            proof.fileIds = fileIds;

            bankAccount.proofs = [proof];
        }
        await this.bankAccountService.update(bankAccount);
    }

    public async removeBankStatementFile(fileId: string): Promise<void> {
        const loanApplication = await this.loanApplicationInteractor.get();
        const bankAccount = await this.get(loanApplication.bankAccountId);
        if (bankAccount.proofs[0].fileIds.length > 1) {
            bankAccount.proofs[0].fileIds.splice(bankAccount.proofs[0].fileIds.indexOf(fileId), 1);
        } else {
            bankAccount.proofs = [];
        }
        await this.bankAccountService.update(bankAccount);
    }
}
